class CommomConfig {

    testmsg = "111";

    getTableStatusClass(status:number){
        if (status == 0) {
            return "success";
          } else if (status == 1) {
            return "warning";
          } else {
            return "disabled";
          }
    }

}

export default CommomConfig